module.exports = __webpack_public_path__ + "img/renew.0903e6c0.png";